import React from 'react';
import './TypingIndicator.css';

const TypingIndicator = ({ isUser, userName, isBot, communityName }) => {
  if (isBot) {
    return (
      <div className="typing-indicator bot-typing">
        <div className="typing-text">
          <span className="typing-name">{communityName} bot</span> is typing...
        </div>
        <div className="typing-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    );
  }

  if (isUser) {
    return (
      <div className="typing-indicator user-typing">
        <div className="typing-text">
          <span className="typing-name">{userName}</span> is typing...
        </div>
        <div className="typing-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    );
  }

  return null;
};

export default TypingIndicator;